export const gridGameTranslations = {
  es: {
    title: "Parrilla",
    season: "Temporada",
    inputPlaceholder: "Escribe nombre piloto",
    errorInvalidPilot: "Piloto incorrecto para esta casilla. ¡Turno perdido!",
    loading: "Cargando parrilla...",
    back: "Volver al Inicio"
  },
  en: {
    title: "Grid",
    season: "Season",
    inputPlaceholder: "Search driver name",
    errorInvalidPilot: "Invalid driver for this slot. Turn lost!",
    loading: "Loading grid...",
    back: "Back Home"
  }
};
